// Lightweight GA4 + UTM helper. No PII is ever sent in events.
const GA_ID = process.env.REACT_APP_GA_MEASUREMENT_ID;

let initialised = false;

export function initAnalytics() {
  if (initialised || !GA_ID) return;
  initialised = true;
  const s = document.createElement("script");
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(s);
  window.dataLayer = window.dataLayer || [];
  window.gtag = function () {
    window.dataLayer.push(arguments);
  };
  window.gtag("js", new Date());
  window.gtag("config", GA_ID, { anonymize_ip: true });
}

// Persist UTM params for the session so we can attribute leads (no PII).
export function captureUTM() {
  try {
    const p = new URLSearchParams(window.location.search);
    const keys = ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term"];
    const found = {};
    keys.forEach((k) => {
      const v = p.get(k);
      if (v) found[k] = v;
    });
    if (Object.keys(found).length) {
      sessionStorage.setItem("bcb_utm", JSON.stringify(found));
    }
  } catch (e) {
    /* ignore */
  }
}

export function getUTM() {
  try {
    return JSON.parse(sessionStorage.getItem("bcb_utm") || "{}");
  } catch (e) {
    return {};
  }
}

// Fire a named conversion event. Params must NEVER include names, emails or CV text.
export function track(event, params = {}) {
  try {
    if (window.gtag) window.gtag("event", event, { ...getUTM(), ...params });
  } catch (e) {
    /* ignore */
  }
}
